import { useEffect, useMemo, useState } from "react";

export function useMediaQuery(query: string) {
  const mediaQuery = useMemo(() => matchMedia(query), [query]);
  const [matches, setMatches] = useState(mediaQuery.matches);
  function onChange(event: MediaQueryListEvent) {
    setMatches(event.matches);
  }
  useEffect(() => {
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  });
  return matches;
}

export function useBreakpoint(breakpoint: "sm" | "md" | "lg") {
  let query;
  switch (breakpoint) {
    case "sm":
      query = "(min-width: 48rem)";
      break;
    case "md":
      query = "(min-width: 75rem)";
      break;
    case "lg":
      query = "(min-width: 120rem)";
      break;
    default:
      breakpoint satisfies never;
      throw new TypeError("Unreachable");
  }

  return useMediaQuery(query);
}
